angular.module('app', [
  'ngRoute',
  'ngCookies',
  'ngResource', 
  'ngSanitize',
  'ngAnimate',
  'app.controllers',
  'app.resources',
  'app.services',
  'app.directives',
  'app.filters',
  'mwTable',
  'slickCarousel',
  'angular-loading-bar',
  'checklist-model',
  'ng.deviceDetector',
  'infinite-scroll',
  'pascalprecht.translate',
  'ngMeta'
])

  .run([
    '$rootScope', '$route', '$routeParams', 'smoothScr', '$cookies', '$location', '$timeout', 'APICheckin', 'APIChats', 'APIEvent', 'UI', '$window', '$translate', 'APIFavorites', 'ngMeta'
  ].append (root, $route, $routeParams, smoothScr, $cookies, $location, $timeout, APICheckin, APIChats, APIEvent, UI, $window, $translate, APIFavorites, ngMeta) -> 

    ngMeta.init()

    root.overlay    = false
    root.pageLoaded = false
    root.settings   = null
    root.preview    = false
    root.sync_error_is = false

    #
    # first of all load default event settings
    #

    APIEvent.get {_entry: 'eventdata'}, (data) ->
      root.settings = data
      # get session data
      root.$emit 'proveSession'
    , (response) ->
      UI.notify false, "Can't laod application settings"

    #
    # Provide loading state for templates and controllers
    #
    
    root.loading = false
    root.$on 'cfpLoadingBar:started',   -> root.loading = true
    root.$on 'cfpLoadingBar:completed', -> root.loading = false
    
    #
    # Modals
    #

    root.activeAction = false
    activeTimer = null
    closeTimer  = null
    closeHimself = true

    setCloseTimer = (minutes = 5, trigger = '') ->
      console.debug "71 - ", trigger
      closeTimer = $timeout () ->
        root.logout()
        closeHimself = false
        root.inactiveModal.hide()
      , 1000*60*minutes # 5 min

    setActiveTimer = (minutes = 30) ->
      activeTimer = $timeout () ->
        if document.fullscreenElement
          return root.activeAction = true 
        root.inactiveModal.show()
      , 1000*60*minutes # 30 min

    root.inactiveModalEl = document.getElementById('inactiveModal')

    if root.inactiveModalEl?
      root.inactiveModal = bootstrap.Modal.getOrCreateInstance(root.inactiveModalEl)

      root.inactiveModalEl.addEventListener('hide.bs.modal', (event) ->
        root.$broadcast('sendCustomStat', null, 'timeout_close', 'User closed inactivity modal') if closeHimself

        root.activeAction = true
        root.$applyAsync()
      )

      root.inactiveModalEl.addEventListener('show.bs.modal', (event) ->
        root.$broadcast 'sendCustomStat', null, 'timeout', 'User notification about 30 min inactivity'
        setCloseTimer(0.3, "show modal if activeAction = false") unless root.activeAction          
        root.$applyAsync()
      )

    root.$watch 'activeAction', (newObj, oldObj) ->
      console.debug "103 - watch activeAction = ", newObj
      if newObj
        $timeout.cancel(activeTimer) if activeTimer?
        $timeout.cancel(closeTimer) if closeTimer?
        root.activeAction = false
      else if root.session? && root.user?.auth_ticket
        setActiveTimer() unless root.inactiveModalEl?.classList.contains('show')
    , true

    root.iframeInteraction = false

    $window.addEventListener 'focus', (event) ->
      # Ignore focus events from iframe interactions
      return root.iframeInteraction = false if root.iframeInteraction
        
      if root.inactiveModalEl?.classList.contains('show')
        root.activeAction = false
        $timeout.cancel(closeTimer) if closeTimer?
        setCloseTimer(0.3, "?window focus if activeAction = false")

    $window.addEventListener "blur", (event) ->
      # Ignore blur events from iframe interactions
      return root.iframeInteraction = true if document.activeElement?.tagName?.toLowerCase() is 'iframe'
      root.iframeInteraction = false

      if closeTimer? && root.inactiveModalEl?.classList.contains('show')
        root.activeAction = false
        $timeout.cancel(closeTimer)

    #
    # Menu and highlight
    #
    root.menuOpen = false

    menuOffcanvasEl = document.getElementById('offcanvasNavbar')
    if menuOffcanvasEl?
      menuOffcanvas   = new bootstrap.Offcanvas(menuOffcanvasEl) 

      menuOffcanvasEl.addEventListener('show.bs.offcanvas', (event) ->
        root.menuOpen = !root.menuOpen
        root.$applyAsync()
      )

    root.option = (name) ->
      return null unless $route.current?.$$route?.options?
      return null unless $route.current.$$route.options[name]?
      $route.current.$$route.options[name]

    root.at = (menu) ->
      root.menu is menu

    root.get = (param) ->
      $routeParams[param]

    #
    # Update menu item
    #
    logged_in_stat = false

    root.$on '$routeChangeSuccess', (event, next, current) ->
      root.activeAction = true

      root.menu = ''
      root.menu = root.option 'menu' if root.option 'menu'

      if logged_in_stat
        root.$broadcast('sendCustomStat', null, 'logged_in', "Logged in")
        logged_in_stat = false

      # scroll top on route change
      $timeout () -> smoothScr.scroll('#body-top', 0)

      lang = $translate.use() || $cookies.get('NG_TRANSLATE_LANG_KEY') || 'es'
      
      # Force ES language on /soon page (only if not already ES to avoid reload loop)
      if $route.current?.$$route?.originalPath is '/soon'
        currentLang = $translate.use() || langKey || 'es'
        if currentLang != 'es'
          $translate.use('es')

      lang = $translate.use() || langKey || 'es'

    root.$on '$translateChangeEnd', ->
      return unless $translate.use()
      lang = $translate.use() || $cookies.get('NG_TRANSLATE_LANG_KEY') || 'es'
      root.lang = if lang is 'en' then 'en' else lang

      $route.reload()

      loadChat()
      
      root.$broadcast('resetLangVideo') if root.at('home')

    routeReload = false

    root.$on '$routeChangeStart', (event, next, current) ->      
      routeReload = false
      # wait loading required data and stop routing
      if !root.pageLoaded
        routeReload = true
        return event.preventDefault()

      menuOffcanvas.hide() if menuOffcanvas?

      if (current?.$$route?.controller == "ProgramsCtrl" || next?.$$route?.controller == "ProgramsCtrl") && root.user?.auth_ticket && current?.$$route != next?.$$route
        root.$broadcast 'toggleFloatPlayer'
        

      nextPath = next?.$$route?.originalPath || '/logout'

      protectedPath = [] #'/automation-solutions/:id'
      protectedPath2 = ['/automation-solutions']
      
      availablePath = ['/soon'] # '/soon'
      availablePath2 = []

      root.no_access = false
      # if not in public pages
      if nextPath in protectedPath
        unless root.user?.auth_ticket
          event.preventDefault()
          if current?
            return event.preventDefault()
          else
            return $location.path('/soon') # /soon

        # before event allow user only home page and soon event they have access
        if moment().isBefore('2026-06-16 08:30:00')
          if availablePath2.length > 0 && nextPath not in availablePath2
            event.preventDefault()
            return $location.path(availablePath[0])

        if root.user?.role == 'exhibitor'
          unless next.params?.id?
            UI.notify false, 'Current access allowed only to view preview page'
            return root.logout()
          if root.session?.user?.id?
            unless parseInt(next.params.id) == root.session.user.id
              UI.notify false, 'Current access allowed only to view preview page'
              return root.logout()
      else
        unless root.user?.auth_ticket
          if root.settings.registration_link_test && nextPath not in availablePath2
            event.preventDefault()
            return $window.location = root.settings.registration_link 
          # without access link always goes to welcome/soon page
          if availablePath.length > 0 && nextPath not in availablePath
            event.preventDefault()
            return $location.path('/soon') # /soon

        # before event allow user only home page and soon event they have access
        if moment().isBefore('2024-06-16 08:30:00')
          if root.session?.user.id in [1359513] || root.user?.role == 'exhibitor' || root.session?.user.email in []
            root.no_access = false
          else
            root.no_access = true
            if nextPath in protectedPath2
              event.preventDefault()
              return $location.path("/")
            ###
            aP = if root.user?.auth_ticket then availablePath2 else availablePath
            if aP.length > 0 && nextPath not in aP
              event.preventDefault()
              return $location.path(aP[0])
            ###

        else
          root.no_access = false

          if root.user?.role == 'exhibitor'
            unless next.params?.id?
              UI.notify false, 'Current access allowed only to view preview page'
              return root.logout()
            if root.session?.user?.id?
              unless parseInt(next.params.id) == root.session.user.id
                UI.notify false, 'Current access allowed only to view preview page'
                return root.logout()

    #
    # Load chat if ticket exist
    #


    root.chatOpen = false

    loadChat = () ->
      return false
      root.xpo.destroyChat() if root.xpo?

      return unless root.user?.auth_ticket

      root.xpo = new XPOSupport(root.user.auth_ticket, 451, root.lang, '#001034', '#00FFB9', null, "'Siemens'")
      
      root.xpo.onChatWindowOpened () ->
        root.chatOpen = true
        root.overlay = false if root.overlay
        root.$applyAsync()

      root.xpo.onChatWindowClosed () ->
        root.chatOpen = false
        root.$applyAsync()

      root.xpo.onChatPartnerClicked (args) ->
        return unless args?.user_id?
        $location.path("/automation-solutions/#{args.user_id}")
        root.$applyAsync()

    toFixedHex = (num = null) ->
      unless num
        num = Math.random() * (1000 - 1) + 1
        num = root.tuser if root.tuser?

      num = BigInt(num) unless typeof num is 'bigint'

      hex = num.toString(16).padStart(16, '0')

      if hex.length > 16
        hex = hex.slice(-16)

      hex

    #
    # Session data
    #

    root.session  = null
    root.$on 'proveSession', (event, redirect = false, logout = false, autologin = false) -> 

      root.user  = $cookies.getObject('user') || null
      root.tuser = $cookies.get('tuser') || null
      
      if logout
        $location.search('auth_ticket', null)
        $location.search('auth_token', null)
      else
        locPath   = $location.path()
        locParams = $location.search()

        if locParams.auth_ticket && String(locPath).indexOf('automation-solutions/') != -1
          root.user = 
            auth_ticket: locParams.auth_ticket
            role: 'exhibitor'

          # preview mode ON but check if ticket is exhibitor after getting details
          root.preview = true
        pseudoLogin = false
        # login via link
        if locParams.auth_token || locParams.auth_ticket
          newAuth = locParams.auth_token || locParams.auth_ticket

          redirect = true
          if !root.user?.auth_ticket || (root.user?.auth_ticket != newAuth)
            pseudoLogin = true
          else
            #$location.search('auth_ticket', null)
            #$location.search('auth_token', null)
            console.debug "clear location auth"

          root.user = 
            auth_ticket: locParams.auth_token || locParams.auth_ticket
          root.preview = false

      unless root.user?.auth_ticket?
        $route.reload() if routeReload
        unless root.tuser?
          root.tuser = Date.now()
          $cookies.put('tuser', root.tuser)
        
        root.$broadcast 'getFavorites'

        return root.pageLoaded = true

      APICheckin.get {auth_ticket: root.user.auth_ticket, _private: true}, (data) ->
        (new APIFavorites {auth_ticket: root.user.auth_ticket, shortcode: data.shortcode, role: data.role}).$save {shortcode: data.user.email, entrycode: 'reg', exhibitor_id: 111} if locParams?.auth_ticket || locParams?.auth_token

        if pseudoLogin || autologin
          logged_in_stat = true
          pseudoLogin = false
          $location.search('auth_ticket', null)
          $location.search('auth_token', null)
        else
          logged_in_stat = false

        root.session = data        

        root.user.shortcode = data.shortcode unless root.user.shortcode
        root.user.role      = data.role
        
        if data.shortcode_supplementary
          root.tuser = data.shortcode_supplementary
          $cookies.put('tuser', root.tuser)

        $cookies.putObject('user', root.user)

        root.preview = false        
                  
        if root.user.role == 'exhibitor'
          root.preview = true

          if root.get('id')
            return root.logout() unless parseInt(root.get('id')) == data.user.id

        loadChat()

        root.pageLoaded = true
        root.$broadcast('getFavorites')
        #root.$broadcast('displayTips')

        #root.$broadcast('showCountryModal') unless root.session.user.country

        return $route.reload() if routeReload
        return $location.path('/') if redirect
    
      , (response) ->
        UI.notify false, response.data.error
        root.logout()

    root.logout = (redirect = true) ->

      root.$broadcast 'sendCustomStat', null, 'logged_out', "Logged out from #{root.ngMeta.title || 'Home'} page"
    
      root.$broadcast 'closeAllTips'

      root.preview  = false
      root.user     = null
      root.session  = null
      $cookies.remove 'user'
      $cookies.remove 's_e451_tips'
      
      root.$emit 'proveSession', false, true

      $location.path('/logout') if redirect
      root.$applyAsync()
  )   

  .config ['$routeProvider', '$locationProvider', 'cfpLoadingBarProvider', '$qProvider', '$cookiesProvider', '$translateProvider', '$animateProvider', 'ngMetaProvider', (r, l, c, q, co, t, a, n) ->
    
    a.classNameFilter(/animate-/)

    now = new Date()
    co.defaults.expires = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 100)

    n.useTitleSuffix(true)
    n.setDefaultTitle('Siemens Smart Day')
    n.setDefaultTitleSuffix(' | Siemens Smart Day')

    q.errorOnUnhandledRejections(false)
    
    l.html5Mode(true)
    l.hashPrefix('')

    c.includeSpinner = false

    t.useStaticFilesLoader
      prefix: 'assets/langs/locale-'
      suffix: '.json'

    t.preferredLanguage('es')
    t.useCookieStorage()
    t.fallbackLanguage('es')

    r.when '/',
      controller: 'HomeCtrl'
      templateUrl: if moment().isBefore('2026-06-16 08:30:00') then "html/home_before.html" else "html/home.html"
      options:
        menu: 'home'
      data:
        meta:
          title: 'Home'
          description: 'Home'
    
    r.when '/automation-solutions',
      controller: 'ExhibitorsListCtrl'
      templateUrl: "html/exhibitors/list.html"
      options:
        menu: 'exhibitors'
      data:
        meta:
          title: 'Automation Solutions'
          description: 'Automation Solutions'
        
    r.when '/automation-solutions/:id',
      controller: 'ExhibitorsViewCtrl'
      templateUrl: "html/exhibitors/detail.html"
      options:
        menu: 'exhibitors'
      data:
        meta:
          title: 'Automation Solutions'
          description: 'Automation Solutions'
      
      resolve:
        data: ['$route', 'ngMeta', 'APIRead', '$rootScope', ($route, ngMeta, APIRead, root) ->
          APIRead.query {exhibitor: $route.current.params.id, entry_type: 'campaign,usecase', lang: root.lang || 'es'}, (data) ->
            
            if data.length > 0
              ngMeta.setTitle(data[0].title)
              ngMeta.setTag('description', data[0].description || data[0].title)

        ]

    r.when '/program',
      controller: 'ProgramsCtrl'
      templateUrl: "html/programs.html"
      options:
        menu: 'programs'
      data:
        meta:
          title: 'Program'
          description: 'Program'

    r.when '/speaker-experts',
      controller: 'SpeakersCtrl'
      templateUrl: "html/speakers_it.html"
      options:
        menu: 'speakers'
      data:
        meta:
          title: 'Speaker & Experts'
          description: 'Speaker & Experts'

    ###
    r.when '/video',
      controller: 'VideosListCtrl'
      templateUrl: "html/videos.html"
      options:
        menu: 'videos'
      data:
        meta:
          title: 'Videos'
          description: 'Videos'
    ###
    r.when '/deepdivesessions',
      controller: 'VideosListCtrl'
      templateUrl: "html/videos-deep.html"
      options:
        menu: 'videos-deep'
      data:
        meta:
          title: 'Deep Dive Sessions'
          description: 'Deep Dive Sessions'
  
    
    r.when '/favorites',
      controller: 'FavoritesListCtrl'
      templateUrl: "html/favorites.html"
      options:
        menu: 'favs'
      data:
        meta:
          title: 'Favorites'
          description: 'Favorites'

    r.when '/soon',
      controller: 'EmptyCtrl'
      templateUrl: "html/welcome.html"
      options:
        menu: 'auth'
      data:
        meta:
          title: 'Soon'
          description: 'Soon'

    r.when '/registration',
      controller: 'RegistrationCtrl'
      templateUrl: "html/auth/registration.html"
      options:
        menu: 'auth'
      data:
        meta:
          title: 'Registration'
          description: 'Registration'

    r.when '/forgot-login',
      controller: 'PasswordCtrl'
      templateUrl: "html/auth/forgot.html"
      options:
        menu: 'auth'
      data:
        meta:
          title: 'Forgot login'
          description: 'Forgot login'
    
    r.when '/confirm',
      controller: 'ConfirmCtrl'
      templateUrl: "html/auth/confirm.html"
      options:
        menu: 'auth'
      data:
        meta:
          title: 'Confirm registration'
          description: 'Confirm registration'
    
    r.when '/docs',
      controller: 'DocsCtrl'
      templateUrl: "html/docs.html"
      options:
        menu: 'docs'
      data:
        meta:
          title: 'Documentation & Offers'
          description: 'Documentation & Offers'

    ###
    ###
    r.when '/auth',
      controller: 'AuthCtrl'
      templateUrl: "html/auth/empty.html"
      options:
        menu: 'auth'
      data:
        meta:
          title: 'Auth'
          description: 'Auth'

    r.otherwise
      redirectTo: '/automation-solutions'

  ]